import { FastlyImage } from '@components/common/image'
import { THIRD_FOLD_DATA } from '@lib/data/teacher-lp'

const IMAGE_PATH = '/images/teacher-lp/thirdFold/'

type Props = {
  handleBecomeTeacher: () => void
}

const ThirdFold = ({ handleBecomeTeacher }: Props) => (
  <div className="mt-24">
    <div className="container mx-auto flex flex-col gap-8 px-4 md:px-16">
      {THIRD_FOLD_DATA.map((data, index) => (
        <div
          key={data.title}
          className="flex flex-col md:grid md:grid-cols-2 md:items-center"
        >
          {index % 2 === 0 ? (
            <div>
              <FastlyImage
                src={`${IMAGE_PATH}${data.icon}.png`}
                alt={`${data.title} image`}
                height="300"
                width="450"
              />
            </div>
          ) : (
            <div className="md:order-1">
              <FastlyImage
                src={`${IMAGE_PATH}${data.icon}.png`}
                alt={`${data.title} image`}
                height="300"
                width="450"
              />
            </div>
          )}

          <div className="md:flex md:flex-col md:justify-center">
            <div className="flex flex-col items-center md:items-baseline pt-6 pb-3">
              <p className="font-700 text-3xl md:text-5xl text-center md:text-left text-grey-900 leading-9 md:leading-10">
                {data.title}
              </p>
              <div className="border-2 border-orange w-12 mt-2" />
            </div>
            <p className="font-400 text-xl md:text-2xl text-grey-900 text-center md:text-left leading-6 md:leading-7">
              {data.description}
            </p>
          </div>
        </div>
      ))}
    </div>
    <div className="md:flex md:justify-center pt-12 md:pt-20 px-4 md:px-0">
      <button
        onClick={handleBecomeTeacher}
        className="btn btn-orange py-3 md:text-xl text-2xl text-center md:text-left font-600 w-full md:w-auto"
      >
        Become a teacher
      </button>
    </div>
  </div>
)

export default ThirdFold
